import React from "react";
import {
  BankSelect,
  useImportBankSelect,
} from "@features/bankSelect/components/BankSelect";

interface Props {
  onClose: () => void;
}

/**
 * Bank picker for starting an import in place, without navigating to the
 * /import-bank-connection/select-bank route. Mount it only while open so the
 * bank search is not requested in the background.
 */
export const ImportBankSelectModal = ({ onClose }: Props) => {
  const { banks, isFetching, searchValue, onChange, onSelect } =
    useImportBankSelect();

  return (
    <BankSelect
      banks={banks}
      isFetching={isFetching}
      searchValue={searchValue}
      onChange={onChange}
      onSelect={onSelect}
      onClose={onClose}
    />
  );
};
